var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNews = function SvgNews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    color: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 15V9c0-2.828 0-4.243-.879-5.121S14.828 3 12 3H8c-2.828 0-4.243 0-5.121.879S2 6.172 2 9v6c0 2.828 0 4.243.879 5.121S5.172 21 8 21h12M6 8h8m-8 4h8m-8 4h4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8h1c1.414 0 2.121 0 2.56.44S22 9.585 22 11v8a2 2 0 1 1-4 0z"
  })));
};
export default SvgNews;